import { useContainer } from './useContainer.js';
/** Resolves an injectable service from the nearest IoC container. */
export function useService(service) {
    return useContainer().resolve(service);
}
//# sourceMappingURL=useService.js.map